import { useReducer, useCallback } from 'react';
import AdminDragPinPreview from './AdminDragPinPreview';

/**
 * Wrapper yang menyediakan questionState & dispatch lokal
 * supaya AdminDragPinPreview bisa jalan interaktif (drag & drop)
 * tanpa perlu Redux store.
 *
 * Props sama dengan AdminDragPinPreview, tapi tanpa perlu dispatch/questionState dari luar.
 */
export default function InteractiveDragPinPreview({
  presetRoomCount,
  presetPinCount,
  presetPinCustomNames,
  presetRoomCustomNames,
  presetExplanation,
  keyAnswerText,
  dragpinPins,
}) {
  const reducer = (state, action) => {
    switch (action.type) {
      case 'question/setQuestion':
        return { ...state, ...action.payload };
      default:
        return state;
    }
  };

  const [questionState, dispatch] = useReducer(reducer, {
    id: 'preview',
    answerText: [],
  });

  const stableDispatch = useCallback((action) => dispatch(action), []);

  return (
    <AdminDragPinPreview
      isExplanation={false}
      presetRoomCount={presetRoomCount}
      presetPinCount={presetPinCount}
      presetPinCustomNames={presetPinCustomNames}
      presetRoomCustomNames={presetRoomCustomNames}
      presetExplanation={presetExplanation}
      keyAnswerText={keyAnswerText}
      dragpinPins={dragpinPins}
      questionState={questionState}
      dispatch={stableDispatch}
    />
  );
}
